import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Pagination from "react-bootstrap/Pagination";
import { useEffect, useState } from "react";
import axios from "axios";
import IssueTable from "./IssueTable";
import { ThemeProvider, createTheme } from "@mui/material";
import { errorToast } from "../../common/ToastMessage";
import Loader from "../../common/Loader";

let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  );
}

function IssueAccept() {
  const [issueAccept, setIssueAccept] = useState();
  const [isActive, setLoaderActive] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAcceptDetails();
  }, []);

  const getAcceptDetails = async (id) => {
    setLoaderActive(true);
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_PROD}/api/Issue/AcceptedIssues`,
      {
        headers: headers,
      }
    )
      .then(function (response) {
        setLoaderActive(false);
        if (response?.status == "200") {
          const tempdata = response.data.data;
          const AcceptData = tempdata?.map((item, index) => {
            return { ...item, no: index + 1 };
          });
          setIssueAccept(AcceptData)
        }
      })
      .catch(function (error) {
        console.log("error::---", error);
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  };

  const defaultMaterialTheme = createTheme();

  return (
    <>
      <Loader isLoading={isActive} />
      <div className="issue">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="">
                <Row>
                  <Col sm={12}>
                    <Breadcrumb>
                      <Breadcrumb.Item href="#">Issue</Breadcrumb.Item>
                      <Breadcrumb.Item active>Accept Issue</Breadcrumb.Item>
                    </Breadcrumb>
                  </Col>
                  <Col sm={12}>
                    <Card className="border-0 in-tbl-right-card">
                      <Card.Body className="p-0">
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <IssueTable
                            issue={issueAccept}
                            isCalledFrom="accept"
                            title={"Accept Issue"}
                            getAcceptDetails={getAcceptDetails}
                          />
                        </ThemeProvider>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Container>
          </main>
        </div>
      </div>
    </>
  );
}

export default IssueAccept;
